import { useGetUserGetUserProfile } from '../services';

export const userInfo = () => {
  const { data } = useGetUserGetUserProfile({ refetchOnWindowFocus: false });

  return {
    name: data?.data?.nameAndFamily,
    userName: data?.data?.userName,
    avatar: data?.data?.avatar,
  };
};
